const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// Options réparties sur deux emplacements ; "a" = emplacement par défaut
const RULES = [
  { test: (n) => n.includes("mangeoire") && n.includes("support"), a: "Intérieur", b: "Extérieur" },
  { test: (n) => n.includes("sulky"), a: "En bas des portes", b: "En haut des portes" },
];

export const placeCfg = (opt) => RULES.find((r) => r.test(norm(opt?.name))) || null;
export const isPlaceOpt = (opt) => !!placeCfg(opt);

export const placeOf = (opt, qty, place) => {
  if (place && (place.a || place.b)) return { a: place.a || 0, b: place.b || 0 };
  return { a: qty, b: 0 };
};

export const placeLabel = (opt, p) => {
  const c = placeCfg(opt);
  return [p.a > 0 && `${c.a} x${p.a}`, p.b > 0 && `${c.b} x${p.b}`].filter(Boolean).join(", ");
};
